export const DEFAULT_RIGHTS = {
  fastForward: true,
  pause: true,
  rewind: true,
  seek: true,
  adsPause: true,
  adsRewind: true,
  adsFastForward: true,
};

const extractRights = (metadataRights = {}) => {
  const rights = {
    ...DEFAULT_RIGHTS,
    ...metadataRights,
  };

  return {
    ...rights,

    // UX rule: only enable seek if both rewind and fast-forward is allowed
    seek: rights.fastForward && rights.rewind,
  };
};

export const findShowEpisodeByPlayableId = (show, playableId) => {
  const seasons = show.seasons || [];

  for (let i = 0; i < seasons.length; i += 1) {
    const episodes = seasons[i].episodes || [];

    for (let j = 0; j < episodes.length; j += 1) {
      const episode = episodes[j];

      if (episode.playables?.find(item => item.id === playableId)) {
        return episode;
      }
    }
  }

  return null;
};

export function extractViewableRights(viewable, assetId) {
  if (!viewable) {
    return DEFAULT_RIGHTS;
  }

  if (viewable.__typename === 'Channel') {
    return extractRights(
      viewable.broadcastById?.rights
      || viewable?.schedule?.[0]?.rights
      || viewable.playable.rights,
    );
  }

  if (viewable.__typename === 'Show') {
    const episode = findShowEpisodeByPlayableId(viewable, assetId);
    const playable = episode?.playables.find(item => item.id === assetId);

    return extractRights(playable?.rights);
  }

  return extractRights(viewable.defaultPlayable?.rights);
}
